import { superAdminGet, superAdminPut, superAdminPost } from './api';
import { RosterHistoryStatus, RosterImportPreview } from '../admin/studentHistory';
import { HistoryTraitField } from 'Src/helpers/slt/historyTraits';

export const getSuperAdminStudentHistory = (schoolId: string): Promise<RosterHistoryStatus> =>
  superAdminGet(`/schools/${schoolId}/studentHistory`);

export const saveSuperAdminHistoryTraits = (
  schoolId: string,
  fields: HistoryTraitField[],
  revision: number
): Promise<RosterHistoryStatus> => superAdminPut(`/schools/${schoolId}/studentHistory/traits`, { fields, revision });

export const startSuperAdminRosterHistory = (schoolId: string, body = {}): Promise<RosterHistoryStatus> =>
  superAdminPost(`/schools/${schoolId}/studentHistory/baseline`, body);
export const getSuperAdminRosterTemplate = (schoolId: string): Promise<any[]> =>
  superAdminGet(`/schools/${schoolId}/studentHistory/template`);
export const previewSuperAdminRosterImport = (schoolId: string, body): Promise<RosterImportPreview> =>
  superAdminPost(`/schools/${schoolId}/studentHistory/imports/preview`, body);
export const importSuperAdminRosterHistory = (schoolId: string, body): Promise<RosterHistoryStatus> =>
  superAdminPost(`/schools/${schoolId}/studentHistory/imports`, body);
